import Vue from 'vue';
import Component from 'vue-class-component';
import {InjectReactive, Prop, Watch} from 'vue-property-decorator';
import {DynamicElement} from '../../../Models';

@Component
export default class VisitorSurveyElement extends Vue {
  @Prop({type: DynamicElement, required: true}) element: DynamicElement | undefined;
  @Prop({required: true}) initial: any | null | undefined;
  @Prop({type: Boolean, required: false}) validateSurvey: boolean = false;
  @InjectReactive() readonly showErrors!: boolean;

  private formData: {
    question: string | { [key: string]: string },
    answer: string | { id: string, value: any, language: string, originalId: string } | null,
    questionId: number | string | null,
    type: number | null,
  } = {
    question: '',
    answer: '',
    questionId: null,
    type: null,
  };

  private TYPE_INPUT: number = DynamicElement.TYPE_INPUT;
  private TYPE_SELECT: number = DynamicElement.TYPE_SELECT;
  private TYPE_RADIO: number = DynamicElement.TYPE_RADIO;

  created() {
    if (this.element) {
      this.formData.question = this.element.config.question;
      this.formData.questionId = this.element.id;
      this.formData.type = this.element.type;
      if (this.element.type === this.TYPE_INPUT) {
        this.formData.answer = '';
      } else {
        this.formData.answer = this.getDefaultValue(this.element.config.defaultValue);
      }
    }
    if (this.initial) {
      this.formData.question = this.initial.question;
      this.formData.answer = this.initial.answer;
    }
  }

  getDefaultValue(defaultOptionId: string): { id: string, value: any, language: string, originalId: string } | null {
    if (this.element) {
      const result = this.element.config.options.find(o => o.id === defaultOptionId);
      return result ? result : null;
    }
    return null;
  }

  get isValid(): boolean {
    if (this.element && this.element.config.isRequired) {
      if (this.element.type === this.TYPE_INPUT) {
        return this.formData.answer !== null && `${this.formData.answer}`.length > 0;
      } else {
        if (this.element.config.options.length > 0) {
          return this.formData.answer !== null && (typeof this.formData.answer !== 'string' ? this.formData.answer.value.length > 0 : false);
        }
        return true;
      }
    }
    return true;
  }

  @Watch('formData', {deep: true})
  onFormDataChanged(value: any) {
    const valid = this.isValid;
    this.$emit('update', {value, valid});
  }
}
